module.exports = __webpack_public_path__ + "img/brayden-law-1407613-unsplash.a2295d34.jpg";